import { Phone, MessageCircle, Mail, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { BRAND, whatsappLink } from "@/lib/brand";

export const ContactCta = () => {
  return (
    <section id="contact" data-testid="home-contact-section" className="scroll-mt-24 bg-ivory">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="rounded-3xl bg-[#F7F2EA] px-6 sm:px-10 md:px-16 py-10 md:py-14 text-center">
          <Reveal>
            <span className="text-xs tracking-[0.25em] uppercase text-terracotta font-medium">
              Get in Touch
            </span>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-serif text-4xl md:text-5xl font-semibold text-brown max-w-2xl mx-auto">
              Let's find you the right stay in Banaras
            </h2>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="mt-4 text-brown/70 max-w-xl mx-auto">
              Message us on WhatsApp or give us a call — we're happy to help you plan your stay.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="home-whatsapp-cta"
                className="inline-flex items-center gap-2 rounded-full bg-terracotta px-7 py-3.5 text-base font-medium text-white hover:bg-terracotta-dark hover:-translate-y-0.5 transition-all duration-300"
              >
                <MessageCircle className="h-5 w-5" /> WhatsApp Us
              </a>
              <a
                href={`tel:${BRAND.phoneRaw}`}
                data-testid="home-call-cta"
                className="inline-flex items-center gap-2 rounded-full border border-brown/25 px-7 py-3.5 text-base font-medium text-brown hover:bg-brown hover:text-ivory transition-colors duration-300"
              >
                <Phone className="h-5 w-5" /> {BRAND.phone}
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.26}>
            <a
              href={`mailto:${BRAND.email}`}
              data-testid="home-email-cta"
              className="mt-6 inline-flex items-center gap-2 text-sm text-brown/60 hover:text-terracotta transition-colors"
            >
              <Mail className="h-4 w-4" /> {BRAND.email}
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default ContactCta;
